import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 8.63333C3.6134 8.63333 3.3 8.94673 3.3 9.33333V14.6667C3.3 15.0533 3.6134 15.3667 4 15.3667H8.63333V20C8.63333 20.3866 8.94673 20.7 9.33333 20.7H14.6667C15.0533 20.7 15.3667 20.3866 15.3667 20V15.3667H20C20.3866 15.3667 20.7 15.0533 20.7 14.6667V9.33333C20.7 8.94673 20.3866 8.63333 20 8.63333H15.3667V4C15.3667 3.6134 15.0533 3.3 14.6667 3.3H9.33333C8.94673 3.3 8.63333 3.6134 8.63333 4V8.63333H4Z",
		stroke: "currentColor",
		strokeWidth: 1.4,
		strokeLinejoin: "round"
	})
});
export { SvgIconCross as ReactComponent };
